import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var getUuidv4 = function getUuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    /* eslint-disable */
    var r = Math.random() * 16 | 0; // | 0 rounds it

    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
    /* eslint-enable */
  });
};
export var setId = function setId(item) {
  var withChildren = Array.isArray(item.children) ? {
    children: item.children.map(setId)
  } : {};
  return _objectSpread(_objectSpread({}, item), {}, {
    id: getUuidv4()
  }, withChildren);
};
export var processMenuItem = function processMenuItem(disableCheckAll) {
  return function (item) {
    var ancestors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var hasChildren = Array.isArray(item.children);
    var hasMoreThanOneLeaves = hasChildren && item.children.filter(function (itm) {
      return !itm.children;
    }).length > 1;
    var processedChildren = hasChildren ? item.children.map(function (toProcess) {
      return processMenuItem(disableCheckAll)(toProcess, [].concat(_toConsumableArray(ancestors), [item]));
    }) : [];
    var checkAllItems = disableCheckAll || item.radio ? null : {
      label: "All ".concat(item.label),
      id: getUuidv4(),
      checkAll: true,
      ancestors: [],
      toCheck: processedChildren.filter(function (children) {
        return !children.children;
      }),
      toUncheck: processedChildren.filter(function (children) {
        return !children.children;
      })
    };
    var withChildren = hasChildren ? {
      children: hasMoreThanOneLeaves && !disableCheckAll ? [checkAllItems].concat(_toConsumableArray(processedChildren.map(function (child) {
        return _objectSpread(_objectSpread({}, child), {}, {
          toCheck: processedChildren.filter(function (children) {
            return !children.children;
          }).map(function (_ref) {
            var id = _ref.id;
            return id;
          }),
          toUncheck: item.radio ? [] : [checkAllItems]
        });
      }))).filter(function (innerItem) {
        return !!innerItem;
      }) : processedChildren
    } : {};
    return _objectSpread(_objectSpread(_objectSpread({}, item), withChildren), {}, {
      ancestors: ancestors
    });
  };
};
export var setInitialItems = function setInitialItems(preselectedItems, key) {
  return function (checkedItems, item) {
    if (!item.children && preselectedItems.indexOf(item[key]) > -1) {
      return [].concat(_toConsumableArray(checkedItems), [_objectSpread({}, item)]);
    }

    return Array.isArray(item.children) ? item.children.reduce(setInitialItems(preselectedItems, key), checkedItems) : checkedItems;
  };
};
export var areAllSiblingsChecked = function areAllSiblingsChecked(item, checkedItems) {
  var subtrahend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var totalSiblingChecked = checkedItems.filter(function (_ref2) {
    var id = _ref2.id;
    return item.toCheck && item.toCheck.indexOf(id) > -1;
  }).length;
  return item.toCheck && totalSiblingChecked === item.toCheck.length - subtrahend;
};
export var flattenItems = function flattenItems(items) {
  return items.reduce(function (reduced, item) {
    return Array.isArray(item.children) ? [].concat(_toConsumableArray(reduced), [item], _toConsumableArray(flattenItems(item.children))) : [].concat(_toConsumableArray(reduced), [item]);
  }, []);
};
export var setInitialState = function setInitialState(props, processedMenu) {
  var checkedItems = props.checkedItems ? processedMenu.reduce(setInitialItems(props.checkedItems, props.itemKey), []) : [];
  var checkAllItems = checkedItems.length > 0 && !props.disableCheckAll ? checkedItems.reduce(function (all, item) {
    var allSiblingsChecked = areAllSiblingsChecked(item, checkedItems);
    return allSiblingsChecked ? [].concat(_toConsumableArray(all), _toConsumableArray(item.toUncheck)) : [];
  }, []) : [];
  var uniqueCheckAllItems = checkAllItems.reduce(function (all, item) {
    if (all.map(function (_ref3) {
      var id = _ref3.id;
      return id;
    }).indexOf(item.id) > -1) return all;
    return [].concat(_toConsumableArray(all), [item]);
  }, []);
  var breadCrumbs = props.breadCrumbs.length > 0 ? flattenItems(processedMenu).filter(function (item) {
    return props.breadCrumbs.indexOf(item[props.itemKey]) > -1;
  }) : props.breadCrumbs;
  return {
    open: props.open,
    breadCrumbs: breadCrumbs,
    canRenderTitle: true,
    direction: 'forwards',
    checkedItems: [].concat(_toConsumableArray(checkedItems), _toConsumableArray(uniqueCheckAllItems)),
    minHeight: 180
  };
};